'use strict';

function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}

// ==========================
// Solution Microsoft team
// ==========================

if (document.querySelector('.templates__content')) {


    var content = document.querySelectorAll('.templates__content > div');

    var slider = $('.slider');
    var cur = void 0,
        next = void 0,
        next2 = void 0,
        prev = void 0,
        prev2 = void 0;

    slider.on('init', function (event, slick, currentSlide) {
        cur = $(slick.$slides[slick.currentSlide]);
        next = cur.next();
        next2 = cur.next().next();
        prev = cur.prev();
        prev2 = cur.prev().prev();

        prev.addClass('slick-sprev');
        next.addClass('slick-snext');
        prev2.addClass('slick-sprev2');
        next2.addClass('slick-snext2');
        cur.removeClass('slick-snext').removeClass('slick-sprev').removeClass('slick-snext2').removeClass('slick-sprev2');
        slick.$prev = prev;
        slick.$next = next;
    }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
        var cur = $(slick.$slides[nextSlide]);

        slick.$prev.removeClass('slick-sprev');
        slick.$next.removeClass('slick-snext');
        slick.$prev.prev().removeClass('slick-sprev2');
        slick.$next.next().removeClass('slick-snext2');
        next = cur.next(), prev = cur.prev();
        prev2.prev().prev();
        next2.next().next();
        prev.addClass('slick-sprev');
        next.addClass('slick-snext');
        prev.prev().addClass('slick-sprev2');
        next.next().addClass('slick-snext2');
        slick.$prev = prev;
        slick.$next = next;
        cur.removeClass('slick-next').removeClass('slick-sprev').removeClass('slick-next2').removeClass('slick-sprev2');
    });

    slider.slick(_defineProperty({
        speed: 1000,
        dots: true,
        focusOnSelect: true,
        infinite: true,
        centerMode: true,
        slidesPerRow: 1,
        slidesToShow: 1,
        slidesToScroll: 1,
        centerPadding: '0',
        swipe: true,
        prevArrow: $('.slick-prev'),
        nextArrow: $('.slick-next'),
        customPaging: function customPaging(slider, i) {
            return '';
        }
    }, 'infinite', false));

    slider.on('beforeChange', function (slick, currentSlide, i) {
        setTimeout(function () {
            content.forEach(function (item) {
                return item.classList.remove('is-active');
            });
            content[currentSlide.currentSlide].classList.add('is-active');
        }, 100);
    });
}




// =====================
// TrustRadius slider
// =====================

setTimeout(function () {

    function updateSlide() {
        var slide = $('.tr-card');

        slide.each(function () {
            if ($(this).css('visibility') == 'hidden') $(this).hide();
            else $(this).show();
        });
    }

    updateSlide();

    $('.tr-right-navigation').click(function () {
        setTimeout(updateSlide, 100);
    });

    $('.tr-left-navigation').click(function () {
        setTimeout(updateSlide, 100);
    });
}, 1000);